import { ReactNode } from 'react';

import { Typography } from '@mui/material';

import clsx from 'clsx';
import styled from 'styled-components';

import { Constants } from '@arrived/common';

import { Currency } from '../Currency';

const StyledReturnStatContainer = styled.div`
  &.calculator-return-stat-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 12px;
    border: 2px solid ${({ theme }) => theme.palette.neutrals.platinum};
    gap: ${({ theme }) => theme.spacing(2)};
  }
`;

interface CalculatorReturnStatProps {
  className?: string;
  title: ReactNode | string;
  currency: number;
  unitOfTime: string | ReactNode;
  subTitle: ReactNode | string;
  color?: string;
}

export const CalculatorReturnStat = ({
  className,
  title,
  currency,
  unitOfTime,
  subTitle,
  color,
}: CalculatorReturnStatProps) => {
  return (
    <StyledReturnStatContainer className={clsx('calculator-return-stat-container', className)}>
      <Typography variant="body1">{title}</Typography>
      <Currency value={currency} unitOfTime={unitOfTime} color={color} emphasize />
      <Typography variant="body2">{subTitle}</Typography>
    </StyledReturnStatContainer>
  );
};
